// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"99":"af403d5b","905":"3183097a"}[chunkId] + ".css";
};